/*
* Created on Oct 21, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useEffect, useState} from 'react';
import ic_org_center_svg from '../../static/img/utils/ic-organization-center.svg'
import ic_cookie_gi from '../../static/img/utils/ic-cookies-genreral-information.svg'
import ic_cookie_analytic from '../../static/img/utils/ic-cookies-analytic.svg'
import ic_cookie_functional from '../../static/img/utils/ic-cookies-functional.svg'
import ic_cookie_necessary from '../../static/img/utils/ic-cookies-necessary.svg'
import ic_cookie_social from '../../static/img/utils/ic-cookies-social-media.svg'
import * as ReactDom from "react-dom";
import {useTranslation} from "react-i18next";
import {useCookiesSettings} from "../../context/CookiesSettingContext";
import {AUTHAPI} from "../../service/auth";
import {useAuthService} from "../../hook/AuthServiceHook";

const CookiesSettingsComponent = ({showDialog, setShowDialog, setShowManager}) => {
    const {t} = useTranslation();
    const [section, setSection] = useState('GI');
    const [label, setLabel] = useState('');
    const [text, setText] = useState('');
    const [cookieSettings, setCookieSettings] = useState({FC: true, AC: true, SC: true});
    const {get_cookies_settings} = useCookiesSettings();
    const {AUTHAPI} = useAuthService();

    const fetch_settings = () => {
        const settings = get_cookies_settings();
        setCookieSettings(settings);
    }

    const selectSection = (section) => {
        switch (section) {
            case 'GI':
                setSection('GI')
                setLabel(t('@General Information@'))
                setText(t("@A cookie is a small file placed onto your device that enables QNAP Cloud features and functions. Cookies play an important role in making your web experience better. Without them, browsing the web would be frustrating. Because we value your trust and respect your privacy., you can choose not to accept some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.@"))
                break;
            case 'NC':
                setSection('NC')
                setLabel(t('@Necessary Cookies@'))
                setText(t("@Strictly necessary cookies are classified as cookies that must be present for the website to provide the basic functions of the website. We use security cookies to authenticate users and prevent fraudulent use of login credentials. You can set your browser to block or alert you about these cookies, but some parts of the site may not working properly.@"))
                break;
            case 'FC':
                setSection('FC')
                setLabel(t('@Functional Cookies@'))
                setText(t("@Functionality cookies allow websites to remember the users site preferences and choices they make on the site including username, region, and language. These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.@"))
                break;
            case 'AC':
                setSection('AC')
                setLabel(t('@Analytic Cookies@'))
                setText(t("@Analytic cookies are cookies used specifically for gathering data on how visitors browse aaround our website, which pages of a website are visited most often. This data is aggregated and anonymized. Data such as pages visits, loading time, and loading errors help us improve the design and functionality of our websites. If you do not allow these cookies we will not be able to monitor its performance.@"))
                break;
            case 'SC':
                setSection('SC')
                setLabel(t('@Social Media Cookies@'))
                setText(t("@Social media cookies allow users to interact more easily with social media, such as Facebook and Google. We do not control social media cookies and they do not allow us to gain access to your social media accounts.@"))
                break;
            default:
                setSection('GI')
                setLabel(t('@General Information@'))
                setText(t("@A cookie is a small file placed onto your device that enables QNAP Cloud features and functions. Cookies play an important role in making your web experience better. Without them, browsing the web would be frustrating. Because we value your trust and respect your privacy., you can choose not to accept some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.@"))
        }
    }

    const toggleSwitch = (section) => {
        setCookieSettings((prevSettings)=>{
            prevSettings[section] = !prevSettings[section];
            return {...prevSettings}
        });
    }

    const confirm = () => {
        cookieSettings['is_cookies_set'] = true;
        AUTHAPI.set_cookies(cookieSettings);
        fetch_settings();
        setShowDialog(false);
        setShowManager(false);
    }

    useEffect(()=>{
        selectSection('GI');
        fetch_settings();
    }, [])

    return ReactDom.createPortal(
        <>
            {
                showDialog &&
                    <>
                        <div className="screen-mask visible" />
                        <div className="dialog-wrapper">
                            <div className="dialog dialog-cookie-settings">
                                <div className="dialog-header">
                                    <div className="header-title">
                                        <div className="service-icon">
                                            <img src={ic_org_center_svg} alt=""/>
                                        </div>
                                        <div className="service-title">{t('@{app_name} Cookie Settings@', {app_name: 'Organization Center', interpolation: {prefix: '{', suffix: '}'}})}</div>
                                    </div>
                                    <div className="close" onClick={()=>setShowDialog(false)}/>
                                </div>
                                <div className="dialog-body">
                                    <div className="dialog-content" style={{minHeight: "20rem"}}>
                                        <div className="cookie-settings-wrapper">
                                            <div className="settings-nav">
                                                <ul className="nav-list">
                                                    <li className={`nav-item ${section==='GI' ? 'active' : ''}`} onClick={()=>selectSection('GI')}>
                                                        <span className="item-icon"><img src={ic_cookie_gi} alt=""/></span>
                                                        <span className="item-label">{t('@General Information@')}</span>
                                                    </li>
                                                    <li className={`nav-item ${section==='NC' ? 'active' : ''}`} onClick={()=>selectSection('NC')}>
                                                        <span className="item-icon"><img src={ic_cookie_necessary} alt=""/></span>
                                                        <span className="item-label">{t('@Necessary Cookies@')}</span>
                                                    </li>
                                                    <li className={`nav-item ${section==='FC' ? 'active' : ''}`} onClick={()=>selectSection('FC')}>
                                                        <span className="item-icon"><img src={ic_cookie_functional} alt=""/></span>
                                                        <span className="item-label">{t('@Functional Cookies@')}</span>
                                                    </li>
                                                    <li className={`nav-item ${section==='AC' ? 'active' : ''}`} onClick={()=>selectSection('AC')}>
                                                        <span className="item-icon"><img src={ic_cookie_analytic} alt=""/></span>
                                                        <span className="item-label">{t('@Analytic Cookies@')}</span>
                                                    </li>
                                                    <li className={`nav-item ${section==='SC' ? 'active' : ''}`} onClick={()=>selectSection('SC')}>
                                                        <span className="item-icon"><img src={ic_cookie_social} alt=""/></span>
                                                        <span className="item-label">{t('@Social Media Cookies@')}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="settings-content">
                                                <div className="content-info">
                                                    <div className="info-header">
                                                        <div className="header-title">{label}</div>
                                                        {/*// <!-- 有 Always active 就沒有後面的 switch 按鈕 -->*/}
                                                        {section === 'NC' && <div className="tag-always-active ml-auto">{t('@Always active@')}</div>}

                                                        {['FC', 'AC', 'SC'].includes(section) &&
                                                            <div className="comp-switch ml-auto" onClick={()=>toggleSwitch(section)}>
                                                                {/*// <!-- 開關切換，使用 class: switch-on / switch-off -->*/}
                                                                <div className={`q-switch switch-${cookieSettings[section] ? 'on' : 'off'}`}/>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="info-body">{text}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="dialog-footer clear">
                                    <div className="pull-right">
                                        <div className="q-btn-group">
                                            {/*// <!-- 正向在左，負向在右 -->*/}
                                            <button type="button" className="q-btn q-btn-primary" onClick={confirm}>{t('@Confirm my choices@')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>,
        document.getElementById('modal-dialog')
    );
}

export default CookiesSettingsComponent;